import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { fetchExerciseDetailsByKey } from "sj-ui-toolkit/src/api";
import { FullScreenLoader } from "sj-ui-toolkit/src/components";

import { useLessonLoader } from "../../hooks/useLessonLoader";
import VideoLesson from "../Lesson/VideoLesson";

export default function ExercisePage() {
  // Enable flex layout for this page
  const { "*": contentKey } = useParams();
  const [exerciseContent, setExerciseContent] = useState(null);
  const navigate = useNavigate();
  const { isLessonLoaded, lessonDetails } = useLessonLoader(null, null, exerciseContent);

  const onLessonFinish = () => {
    navigate("/");
  };

  useEffect(() => {
    const fetchExercise = async () => {
      try {
        const data = await fetchExerciseDetailsByKey(contentKey);
        setExerciseContent(data);
      } catch (error) {
        console.error("Error fetching exercise details:", error);
      }
    };

    fetchExercise();
  }, []);

  if (!isLessonLoaded || !exerciseContent) {
    return <FullScreenLoader />;
  }

  return (
    <VideoLesson
      lessonDetails={lessonDetails}
      onLessonFinish={onLessonFinish}
      exerciseOnly={true}
    />
  );
}
